import type { Job } from '@/domains/jobs/components/JobCard';
import { type PlannerEvent, usePlannerEvents } from '@/domains/planner';
import { addDays } from 'date-fns';
import { useMemo } from 'react';
import { buildMemberJobs } from '../lib/memberJobs';

const NO_EVENTS: PlannerEvent[] = [];

/** Per-member job bars for the Gantt: planner events for the visible window joined onto on-screen jobs. Only fetches while `enabled` (a team is expanded). */
export function useMemberJobs(
  jobs: Job[],
  rangeStart: Date,
  daysToShow: number,
  enabled: boolean,
): { memberJobs: Map<string, Job[]>; isError: boolean } {
  const { data: events = NO_EVENTS, isError } = usePlannerEvents(
    rangeStart.toISOString(),
    addDays(rangeStart, daysToShow).toISOString(),
    undefined,
    { enabled },
  );
  const memberJobs = useMemo(() => buildMemberJobs(events, jobs), [events, jobs]);
  return { memberJobs, isError };
}
